export default "__VITE_ASSET__aMPWaXT0__"